module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-ALTER-1-25-small-dc446397be62b9d041b010c729151c28.png";